import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { postCompensationWithHandler } from '../../../../../global/ducks/benadmin-api';
import { formatDate, parseChanged } from '../../../../../global/helpers/form-data-helper';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { CompensationResponseData } from '../compensation-history/compensation-history-model';
import { addOneTimePayment, setUpdateCompensationStatus } from '../compensation-history/compensation-history-slice';
import { OneTimePaymentFormValues } from './one-time-payment-form-model';

export const oneTimePayment = (
	dispatch: Dispatch<any>,
    employeeId: string | number,
    employmentId: number,
    savedValues: OneTimePaymentFormValues,
    formValues: OneTimePaymentFormValues) => {

	const changed = parseChanged(savedValues, formValues);
	if (isEmpty(changed)) {
		return;
	}

	dispatch(apiErrorClear());

	const payload = {
		otp: {
			...formValues,
			effective_date: formatDate(formValues.effective_date),
		},
        employee_id: employeeId,
		employment_id: employmentId,
	};


	const postSuccess = (responseData: CompensationResponseData) => {
		dispatch(addOneTimePayment(responseData));
		dispatch(setUpdateCompensationStatus(ApiStatuses.Success));
	};

    dispatch(postCompensationWithHandler(employeeId, employmentId, payload, (postResponse) => postSuccess(postResponse.data)));
};

